import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserRightsXsState } from '../../states/user-rights/user-rights-xs.state';
import { UserRoleIdUtil } from '../../utils/UserRoleIdUtil';

@Injectable()
export class ClientModeRoleGuard implements CanActivate, CanMatch {

  constructor(
    private router: Router,
    private store: Store
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.can();
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<UrlTree> | Promise<UrlTree> | boolean | UrlTree {
    return this.can();
  }

  private can(): boolean {
    const userRoleId = this.store.selectSnapshot(UserRightsXsState.activeUserRightsRoleId);
    const isClientModeRole = userRoleId != UserRoleIdUtil.SERVICE_TECHNICIAN_ROLE_ID
      && userRoleId != UserRoleIdUtil.SERVICE_PROVIDER_MODULE_ADMIN_ROLE_ID;
    if (!isClientModeRole) {
      this.router.navigate(['/home']);
    }
    return isClientModeRole;
  }

  public canAccess() : boolean {
    return this.can();
  }

}
